import API from "@lib/api";
import { BaseApi } from "@api";
import { QueryUtils } from "@utils";
import { Messages, QueryFilter } from "@interfaces";

import { IMonth, IYearFiscal, IMonthlyClosing } from "../interfaces";

export class MonthlyClosingApi extends BaseApi {
  protected static filterApi = API({ namespace: "Filtro" });
  protected static api = API({ namespace: "CierresMensuales" });
  protected static messages: Messages<typeof MonthlyClosingApi> = {
    create: {
      error: (error) => error,
      loading: "Agregando nuevo mes...",
      success: "Nuevo mes agregado correctamente.",
    },
    changeState: {
      error: (error) => error,
      loading: "Cambiando estado del mes...",
      success: "Se ha cambiado el estado del mes correctamente.",
    },
  };

  public static async getAll() {
    const result = await this.api.get<IMonthlyClosing[]>("GetAll");
    return result.data;
  }

  public static async getAllByFilter(data: {
    filterId: number;
    pageSize: number;
    page: number;
  }) {
    const result = await this.filterApi.get<QueryFilter<IMonthlyClosing[]>>(
      `FiltroPorArea/${data.filterId}${QueryUtils.filter({ Page: data.page, PageSize: data.pageSize })}`,
    );
    return result.data;
  }

  public static async getAllMonths() {
    const result = await this.api.get<IMonth[]>("GetMeses");
    return result.data;
  }

  public static async getAllYearFiscales() {
    const result = await this.api.get<IYearFiscal[]>("GetAllAnioFiscales");
    return result.data;
  }

  public static async create(data: IMonthlyClosing) {
    const result = await this.api.post("Create", data);
    return result.data;
  }

  public static async changeState(data: { Id: number; EstadoId: number }) {
    const result = await this.api.post("ChangeState", data);
    return result.data;
  }
}
